import classNames from 'classnames'

const Flag = (props) => <div class={classNames({ 'flag-success': props.success })}>
  {props.text}
</div>

export default Flag
